import React, { Component } from 'react';
import { matchPath } from 'react-router';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as ChannelsActions } from 'store/ducks/channels';

import { Page, Form, Loading, Breadcrumbs } from 'components';

class Edit extends Component {
  state = {
    data: {
      name: '',
      score: false,
    },
    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Pontos', to: '/points' },
      { name: 'Canais', to: '/points/channels' },
      { name: 'Editar Canal', to: '' },
    ],
  };

  componentDidMount() {
    this.props.getChannelRequest(this.handleGetID());
  }

  componentDidUpdate(oldProps) {
    const { channel } = this.props;

    if (oldProps.channel.loading && !channel.loading) {
      this.setState({
        data: {
          name: channel.data.attributes.name,
          score: channel.data.attributes.score,
        },
      });
    }
  }

  handleGetID = () => {
    const match = matchPath(this.props.location.pathname, { path: '/points/channels/:id/edit' });
    const { id } = match.params;

    return id;
  };

  handleToggleActive = () => {
    const { data } = this.state;

    this.setState({ data: { ...data, score: !data.score } });
  };

  handleSubmit = e => {
    e.preventDefault();
    const { data } = this.state;

    this.props.updateChannelRequest(this.handleGetID(), { channel: { score: data.score } });
  };

  render() {
    const { data, breadcrumbs } = this.state;
    const { update } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form className="page-form">
          <h3 className="form-title">Canal</h3>

          <Form.Field>
            <Form.Label>Canal</Form.Label>
            <Form.Input name="channel" placeholder="Loja" value={data.name} readOnly />
          </Form.Field>

          <Form.Field className="checkbox-field">
            <Form.Label>Ativar canal</Form.Label>
            <Form.Checkbox checked={data.score} onChange={this.handleToggleActive} />
          </Form.Field>

          <div className="buttons">
            <Link to="/points/channels" className="button-cancel">
              Cancelar
            </Link>

            <Form.Button className="button-save" onClick={this.handleSubmit} disabled={update.loading}>
              {update.loading ? <Loading type="btn" size="small" text="Salvando..." /> : 'Salvar'}
            </Form.Button>
          </div>
        </Form>
      </Page>
    );
  }
}

const mapState = state => ({
  channel: state.channels.detail,
  update: state.channels.update,
});

const mapActions = dispatch => bindActionCreators(ChannelsActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Edit);
